import React, { memo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCalendar,
  faEllipsisV,
  faShare,
  faRss
} from '@fortawesome/free-solid-svg-icons';

const RunCard = memo(({ run, index, openMenuId, setOpenMenuId, handleShare, handlePostToFeed }) => (
  <div className="scrapbook-container hover:shadow-lg transition-shadow duration-200">
    <div className="flex items-start justify-between mb-3">
      <div className="flex-1">
        <h3 className="font-heading font-semibold text-lg text-gray-900 mb-1">
          {run.title}
        </h3>
        <div className="flex items-center gap-3 text-sm text-gray-500">
          <span className="flex items-center gap-1">
            <FontAwesomeIcon icon={faCalendar} className="w-4 h-4" />
            {run.date} at {run.time}
          </span>
        </div>
      </div>
      
      <div className="relative">
        <button
          onClick={() => setOpenMenuId(openMenuId === run.id ? null : run.id)}
          className="p-1 text-gray-400 hover:text-gray-600 hover:scale-[1.1] transition-all"
        >
          <FontAwesomeIcon icon={faEllipsisV} className="w-4 h-4" />
        </button>
        
        {openMenuId === run.id && (
          <div className="absolute right-0 top-8 bg-white rounded-xl shadow-lg border border-gray-100 py-1 z-10 min-w-[150px]">
            <button
              onClick={() => handlePostToFeed(run)}
              className="w-full flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
            >
              <FontAwesomeIcon icon={faRss} className="w-4 h-4 text-primary-pink" />
              Post to Feed
            </button>
            <button
              onClick={() => handleShare(run)}
              className="w-full flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
            >
              <FontAwesomeIcon icon={faShare} className="w-4 h-4 text-secondary-blue" />
              Share
            </button>
          </div>
        )}
      </div>
    </div>

    <div className="grid grid-cols-4 gap-4 p-3 bg-gradient-vibe-subtle rounded-xl">
      <div className="text-center">
        <div className="font-bold text-lg text-primary-pink">{run.distance}km</div>
        <div className="text-xs text-gray-600">Distance</div>
      </div>
      <div className="text-center">
        <div className="font-bold text-lg text-secondary-blue">{run.duration}</div>
        <div className="text-xs text-gray-600">Time</div>
      </div>
      <div className="text-center">
        <div className="font-bold text-lg text-primary-yellow">{run.pace}</div>
        <div className="text-xs text-gray-600">Pace</div>
      </div>
      <div className="text-center">
        <div className="font-bold text-lg text-secondary-pink">{run.calories}</div>
        <div className="text-xs text-gray-600">Calories</div>
      </div>
    </div>
  </div>
));

export default RunCard;
